/**
 * Auth0 configuration object
 * Replace these values with your Auth0 application settings
 */
const auth0Config = {
  domain: import.meta.env.VITE_AUTH0_DOMAIN,
  clientId: import.meta.env.VITE_AUTH0_CLIENT_ID,
  authorizationParams: {
    redirect_uri: window.location.origin + '/login/callback',
    // audience: import.meta.env.VITE_AUTH0_AUDIENCE, // Disabled as no external audience is used at the moment
    scope: 'openid profile email',
  },
  logoutParams: {
    /** TODO Figure out logout page */
    returnTo: window.location.origin + '/login',
  },
}

export default auth0Config
